import { Button, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import keycloak from "../../keycloak";
import { CenterLayout } from "../../themes/SwitchTheme";
import { UrlPathRegistration } from "../../url";

const WelcomePage = () => {
  return (
    <CenterLayout>
      <div className="jumbotron">
        <h1>Willkommen</h1>
        <Row className="mt-4">
          <Col>
            <Button color="secondary" block onClick={() => keycloak.login()}>
              Anmelden
            </Button>
          </Col>
        </Row>
        <Row className="mt-3 text-center">
          <Col>
            Neuer Benutzer? <Link to={UrlPathRegistration}>Registrierung</Link>
          </Col>
        </Row>
      </div>
    </CenterLayout>
  );
};

export default WelcomePage;
